import { Button, Modal, Alert, CloseButton, Glyphicon, Checkbox } from 'react-bootstrap';
import React from "react";
import { connect } from 'react-redux';
import { Field, FieldArray, FormSection, reduxForm, change as formValueChange, getFormValues } from 'redux-form';
import moment from 'moment';
import { fetchOrderItems as fetchOrderItemsAction } from '../../actions/orderItems';

import 'react-widgets/dist/css/react-widgets.css';
import 'bootstrap/dist/css/bootstrap.css';
import { DropdownListField, ReadonlyInput, UnstiledCheckbox, SimpleField, ColorInput, TextAreaFieldReadOnly } from '../common/Inputs';
import EditItemRow from './items/EditItemRow';
import DateTimeField from './DateTimePicker';

import * as fetchingState from '../../constants/fetchingState';
import { states, RECEIVING_POINT_ORDER_TYPE, getEditOrderStates, defaultHighlightColor, presetHighlightColors } from '../../constants/orderStates';
import { taxiClasses } from '../../constants/taxiClasses';

import { getAvailablePickupDate, getAvailableOffloadDate, clearPickupAndOffloadDate, manualCompletion } from "../../actions/orders";
import { fetchServices as fetchServicesAction } from "../../actions/services";
import { fetchAddresses as fetchAddressesAction } from '../../actions/addresses';
import { cancel as deliveryCancelAction } from '../../actions/delivery';
import { AddressEdit } from '../common/AddressEdit';
import { formatPhone } from '../../extensions/phoneHelper'
import { getSettings as getSettingsAction } from '../../actions/settings';
import * as settingTypes from '../../constants/settingTypes';
import OrderTotal from './items/OrderTotal';
import SpecialOrderConfirmModal from './SpecialOrderConfirmModal';
import { getDepartmentTypeById, FACTORY } from '../../constants/dcDepartmentTypes';
import * as permissions from '../../constants/permissions';

const formName = 'orderEdit';
const onChange = (values) => {
    if (!values.PickupDatePart || !values.PickupTime)
        return;
}

const validate = (data, props) => {
    const errors = {};
    if (data.Items.some(i => i.ServiceId === 0 && !i.Service)) {
        errors._error = '*Не выбраны услуги';
    }
    if (data.Items.some(i => !i.Amount || i.Amount < 1)) {
        const msg = '*Не введено количество';
        errors._error = errors._error ? `${errors._error} ${msg}` : msg;
    }
    if (data.State === states.find(s => s.Id === 2) || data.State === 2) {
        const acceptErrors = preDeliveryValidation(props.itemsFetching, data.Items, data.PickupAddress, data.DryCleaningDepartmentId, data.PickupDate);
        errors._error = errors._error ? `${errors._error} ${acceptErrors}` : acceptErrors;
    }
    if (data.State === states.find(s => s.Id === 4) || data.State === 4) {
        const acceptErrors = preDeliveryValidation(props.itemsFetching, data.Items, data.PickupAddress, data.DryCleaningDepartmentId, data.OffloadDate);
        errors._error = errors._error ? `${errors._error} ${acceptErrors}` : acceptErrors;
    }
    if (data.AddressError)
        errors.PickupAddress = { Address: data.AddressError };
    return errors;
}
const preDeliveryValidation = (itemsFetching, Items, PickupAddress, DryCleaningDepartmentId, DeliveryDate) => {
    let errors = undefined;
    if (itemsFetching === fetchingState.FETCHED && (!Items || (typeof (Items) !== 'undefined' && Items.length === 0))) {
        errors = '*Не выбрано ни одной услуги';
    }
    if (!PickupAddress || !PickupAddress.Address || PickupAddress.Address === '' ||
        !PickupAddress.GeoAddress || !PickupAddress.GeoAddress.X || !PickupAddress.GeoAddress.Y ||
        PickupAddress.GeoAddress.X === 0 || PickupAddress.GeoAddress.Y === 0) {
        const msg = '*Не выбран адрес клиента';
        errors = errors ? `${errors} ${msg}` : msg;
    }
    if (DryCleaningDepartmentId == null) {
        const msg = '*Не выбрана химчистка';
        errors = errors ? `${errors} ${msg}` : msg;
    }
    if (DeliveryDate == null) {
        const msg = '*Не выбрано время';
        errors = errors ? `${errors} ${msg}` : msg;
    }
    const now = new Date();
    if (DeliveryDate && DeliveryDate < now)
    {
        const msg = '*Нельзя сделать заказ в прошлом';
        errors = errors ? `${errors} ${msg}` : msg;
    }
    return errors;
}
const getOperatorOrderStates = (currentState, orderType) => {
    const availableStates = getEditOrderStates(orderType);
    let operatorOrderStates = [...states.filter(s => {
        return availableStates.some(oes => oes == s.Id)
    })];
    if (!operatorOrderStates.some(oes => oes.Id == currentState))
        operatorOrderStates = [...operatorOrderStates, ...states.filter(s => s.Id == currentState)];

    return operatorOrderStates;
};

let Edit = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: props.initialValues,
            isCancelOpen: false,
            isSpecialDelivery: false,
            specialDeliveryModalShown: false
        };

        this._handleSubmit = this._handleSubmit.bind(this);
        this._onDeliveryCancelOpenClick = this._onDeliveryCancelOpenClick.bind(this);
        this._onSpecialDeliveryCanceled = this._onSpecialDeliveryCanceled.bind(this);
        this._onSpecialDeliveryConfirmed = this._onSpecialDeliveryConfirmed.bind(this);
        this._showSpecialDeliveryModal = this._showSpecialDeliveryModal.bind(this);
        this._showManualCompletionModal = this._showManualCompletionModal.bind(this);
        this._onManualCompletionModalCancelled = this._onManualCompletionModalCancelled.bind(this);
        this._onManualConpletionConfirmed = this._onManualConpletionConfirmed.bind(this);
    }

    _handleSubmit(values) {
        const { onSubmit, initialValues: { State } } = this.props;

        const editModel = {...values}

        editModel.PickupDate = values.PickupDate ? 
            { Date: moment(values.PickupDate, 'DD.MM.YYYY HH:mm'),
            UseDefault: false} : undefined;

        editModel.OffloadDate = values.OffloadDate ? 
            {Date: moment(values.OffloadDate, 'DD.MM.YYYY HH:mm'),
            UseDefault: false} : undefined;
        
        if (editModel['State'] !== State) //in case, state changed
            editModel['State'] = editModel['State']['Id'];

            editModel.Items.forEach(i => {
            if (typeof (i.Service) === 'undefined' || typeof (i.Service.Id) === 'undefined') return;
            let service = i.Service;
            i.Service = service.Name;
            i.ServiceId = service.Id;
            i.CleaningTime = service.CleaningTime;
            i.Price = service.Price;
        });
        editModel.PickupTaxiClass = typeof (editModel.PickupTaxiClass.Id) === 'undefined' ? editModel.PickupTaxiClass : editModel.PickupTaxiClass.Id;
        editModel.OffloadTaxiClass = typeof (editModel.OffloadTaxiClass.Id) === 'undefined' ? editModel.OffloadTaxiClass : editModel.OffloadTaxiClass.Id;
        if (!editModel.HighlightColor)
            editModel.HighlightColor = defaultHighlightColor;
        onSubmit(editModel);
    }

    getDeliveryDate(isNowSelected, isDateChanged, worktimeList, initialDate, valuesIndex) {
        const date = {};
        date.WorkTimeList = worktimeList ? worktimeList : [];
        if (isNowSelected) {
            date.WorkTimeList = [];
            date.IsNow = true;
            return date;
        }
        if (!isDateChanged && initialDate) {
            date.WorkTimeList = [];
            date.UseDefault = true;
        }
        else if (isDateChanged) {
            date.SelectedIndex = valuesIndex;
        }
        else {
            date.WorkTimeList = [];
            date.SelectedIndex = undefined;
        }
        return date;
    }

    componentDidUpdate({ itemsFetching: prevItemsFetching }) {
        const { initialValues: { PartPickupDate, PickupTime, Items }, itemsFetching, getAvailableOffloadDate } = this.props;
        if (!(prevItemsFetching === fetchingState.FETCHING && itemsFetching === fetchingState.FETCHED))
            return;

        if (!PartPickupDate || !PickupTime)
            return;
    }

    componentDidMount() {
        const { itemsFetching, fetchOrderItemsAction, fetchServicesAction, serviceFetching, isNew, services, initialValues: order, delivery, getSettingsAction } = this.props;
        if (!isNew && itemsFetching !== fetchingState.FETCHING || order.Items.length === 0)
            fetchOrderItemsAction({ orderId: order.Id });

        if (serviceFetching !== fetchingState.FETCHING || services.length === 0)
            fetchServicesAction({ category: { Id: 0 }, isActive: { Value: true } });

        if (delivery.fetching !== fetchingState.FETCHING || !delivery.data)
            getSettingsAction(settingTypes.delivery);

        getSettingsAction(settingTypes.departments, 'active');

        this.props.getAvailablePickupDate();
    }

    componentWillUnmount() {
        this.props.clearPickupAndOffloadDate();
    }
    

    _renderModalBody() {
        const { handleSubmit, fetching: updateFetching, change, service, isReceptionPoint, fetchAddressesAction, updateError, fetchedAddresses, initialValues: order, error, delivery, workTime, department } = this.props;
        const orderStates = getOperatorOrderStates(order.State, order.OrderType);
        const formVisible = updateFetching === fetchingState.INITIAL;
        const services = service.map(s => {
            return { Name: `${s.Name} (${s.Price} р.)`, Id: s.Id, Price: s.Price, CleaningTime: s.CleaningTime }
        });
        const filtredDepartments = department.data 
            ? isReceptionPoint ? department.data : department.data.filter(d => d.Type == FACTORY)
            : [];
        const departments = filtredDepartments ? filtredDepartments.map(d => ({ name: `${d.FullName}, ${getDepartmentTypeById(d.Type)}, ${d.Address}`, value: d.Id })) : [];

        const { specialDeliveryModalShown, manualCompletionModalShown } = this.state;

        const renderItemFields = (fields) => {
            return (
                <div>
                    {fields.fields.map((i, index, fields) => (
                        <EditItemRow
                            item={i}
                            key={`Service-${index}`}
                            index={index}
                            services={services}
                            fields={fields} formName={formName} />))}
                    <OrderTotal
                        delivery={delivery.data}
                        services={services}
                        formName={formName}
                        hideDelivery={isReceptionPoint} />
                    <div style={{ paddingRight: '15px', paddingLeft: '15px' }}>
                        <Button onClick={() => fields.fields.push({
                            Id: 0,
                            Price: 0,
                            Amount: 1,
                            Service: undefined,
                            ServiceId: 0,
                            CleaningTime: 0
                        })}>Добавить услугу</Button>
                    </div>
                    {error && <span style={{ color: 'red' }}>{error}</span>}
                </div>
            )
        }

        const renderDateTimePicker = (label, prefix, max, min) => {
            return(
                <div className='row'>
                        <div className='col-md-4'>
                            <span><strong>{label}</strong></span>
                        </div>
                        <div className='col-md-8'>
                            <Field component={DateTimeField} dateTimeFormat='DD.MM.YYYY HH:mm'
                                time={true} max={max} min={min} name={`${prefix}Date`} />
                        </div>
                    </div>
            );
        }
        const renderCommonEditFields = () => {
            return(
                <div>
                    {renderDateTimePicker('Когда забрать', 'Pickup')}
                    <Field name='PickupTaxiClass' component={DropdownListField} data={taxiClasses}
                        valueField="Id" textField="Name" label="Класс такси (забрать заказ)" />
                    {renderDateTimePicker('Когда привезти', 'Offload')}
                    <Field name='OffloadTaxiClass' component={DropdownListField} data={taxiClasses}
                        valueField="Id" textField="Name" label="Класс такси (отвезти заказ)" />
                    {!isReceptionPoint && <Field name='UseAlternativePayment' label='Оплата не через Яндекс' component={UnstiledCheckbox} />}
                </div>
            );
        }
        return (
            <div>
                {formVisible && <form className='form-horizontal' onSubmit={handleSubmit(this._handleSubmit)}>
                    <div style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                        <ReadonlyInput value={order.Id} label="Id" />
                        <ReadonlyInput value={moment(order.CreatedAt).local().format('DD.MM.YYYY HH:mm:ss')} label="Создан" />
                        <ReadonlyInput value={formatPhone(order.Phone)} label="Телефон" />
                        <Field name="Commentary" component={TextAreaFieldReadOnly} label='Комментарий' />
                    </div>

                    <FormSection name="PickupAddress">
                        <AddressEdit geoAddressName="PickupAddress.GeoAddress" editLock={isReceptionPoint} change={change} fetchAddressesAction={fetchAddressesAction} fetchedAddresses={fetchedAddresses} />
                    </FormSection>

                    <div style={{ paddingRight: '15px', paddingLeft: '15px' }}>
                        <Field name='State' component={DropdownListField} data={orderStates}
                            valueField='Id' textField='Name' label='Статус' />
                        {!isReceptionPoint && renderCommonEditFields()}
                        <Field name="DryCleaningDepartmentId" component={DropdownListField} label={isReceptionPoint ? 'Точка приема' : 'Тип отдела'} valueField="value" textField="name"
                            data={departments} disabled={isReceptionPoint} normalize={(value) => value && value.value ? value.value : value} />
                        {!isReceptionPoint && <Field component={ColorInput} label='Цвет' name='HighlightColor' colors={presetHighlightColors} />}

                        <SpecialOrderConfirmModal
                            title="Причина экстренной доставки"
                            onConfirmed={this._onSpecialDeliveryConfirmed}
                            onCanceled={this._onSpecialDeliveryCanceled}
                            show={specialDeliveryModalShown}
                            formName={formName} />
                        <SpecialOrderConfirmModal 
                            title="Причина ручного закрытия заказа"
                            onConfirmed={this._onManualConpletionConfirmed}
                            onCanceled={this._onManualCompletionModalCancelled}
                            show={manualCompletionModalShown}
                            formName={formName}/>
                    </div>

                    <FieldArray name='Items' component={renderItemFields} />

                </form>}
                {updateFetching === fetchingState.FETCHING &&
                    <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                {updateFetching === fetchingState.FETCHED &&
                    <Alert bsStyle='success'>УСПЕХ!</Alert>}
                {updateFetching === fetchingState.FAILED &&
                    <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {updateError && <p>{updateError}</p>}
                    </Alert>}
            </div>
        );
    }

    _onSpecialDeliveryConfirmed() {
        this.setState({
            specialDeliveryModalShown: false,
            isSpecialDelivery: true
        });
        this.props.formValueChange(formName, "isSpecialDelivery", true)
    }

    _showManualCompletionModal() {
        this.setState({manualCompletionModalShown : true});
    }

    _onManualCompletionModalCancelled() {
        this.setState({manualCompletionModalShown : false});
    }

    _onManualConpletionConfirmed() {
        this.props.manualCompletion({
            id: this.props.formValues.Id,
            reason: this.props.formValues.Comment
        });
        this.setState({manualCompletionModalShown : false});
    }

    _showSpecialDeliveryModal() {
        this.setState({
            specialDeliveryModalShown: true
        });
    }

    _onSpecialDeliveryCanceled() {
        this.setState({
            specialDeliveryModalShown: false
        });
    }

    _onDeliveryCancelOpenClick() {
        this.setState({ isCancelOpen: true });
    }

    _renderDeliveryCancel() {
        const { deliveryCancelFetching, deliveryCancelError, onClose } = this.props;
        const showModal = this.state.isCancelOpen && deliveryCancelFetching !== fetchingState.FETCHING;
        const showCancelInfo = (deliveryCancelFetching === fetchingState.FETCHED || deliveryCancelFetching !== fetchingState.FAILED) && this.state.showCancellInfo;
        const _onDeliveryCancelAcceptClick = () => {
            this.props.deliveryCancelAction({ orderId: this.props.initialValues.Id });
            this.setState({ isCancelOpen: false });
            this.setState({ showCancellInfo: true });
        }
        const _onDeliveryCancelCloseClick = () => {
            this.setState({ isCancelOpen: false });
        }
        const _onCancelInfoHideClick = () => {
            this.setState({ showCancellInfo: false });
            onClose();
        }
        return (
            <div>
                {showCancelInfo &&
                    <Modal show={true} >
                        <Modal.Header>
                            <CloseButton onClick={_onCancelInfoHideClick}></CloseButton>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ textAlign: 'center' }}>
                                {deliveryCancelError === null && deliveryCancelFetching !== fetchingState.FETCHING && <span>Доставка Яндекс отменена</span>}
                                {deliveryCancelError !== null && <span>{deliveryCancelError}</span>}
                            </div>
                        </Modal.Body>
                    </Modal>
                }
                <Modal show={showModal}>
                    <Modal.Header>
                        <CloseButton onClick={_onDeliveryCancelCloseClick}></CloseButton>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ textAlign: 'center' }}>
                            <span>Отменить доставку?</span>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type='button' onClick={_onDeliveryCancelAcceptClick}>Да</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

    render() {
        const { itemsFetching, onClose, handleSubmit, fetching: updateFetching, delivery, initialValues: order } = this.props;
        const itemsLoaded = itemsFetching === fetchingState.FETCHED && delivery.fetching === fetchingState.FETCHED;
        const formVisible = updateFetching === fetchingState.INITIAL;
        const closeButtonVisible = updateFetching === fetchingState.FETCHED || updateFetching === fetchingState.FAILED;
        const deleveryCancelButtonVisiblen = permissions.isAllowedFor(permissions.allowDeliveryCancel);
        const showManualCompletionButton = permissions.isAllowedFor(permissions.allowManualCompletion) && updateFetching === fetchingState.INITIAL;
        const isSpecialDeliveryAwailable = permissions.isAllowedFor(permissions.allowedSpecialDelivery);
         
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>
                        <span>Редактирование заказа</span>
                        {showManualCompletionButton &&
                        <Button 
                        style={{ float: 'right' }}
                            onClick={this._showManualCompletionModal}>
                                Ручное завершение
                        </Button>
                    }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {itemsLoaded && this._renderModalBody()}
                    {!itemsLoaded && <div>
                        <span>Загрузка...</span>
                    </div>}
                </Modal.Body>
                {this._renderDeliveryCancel()}
                {itemsLoaded && formVisible && <Modal.Footer>
                    {deleveryCancelButtonVisiblen && <Button type="button" onClick={this._onDeliveryCancelOpenClick} style={{ float: 'left', background: '#FFD700' }}>Отменить доставку</Button>}
                    {isSpecialDeliveryAwailable && (!this.state.isSpecialDelivery ?
                        <Button style={{ float: 'left' }} onClick={this._showSpecialDeliveryModal} >Аварийная доставка</Button>
                        : <div style={{ float: 'left', color: 'green', padding: '6px 12px' }}>
                            <span>Аварийная доставка <Glyphicon glyph='ok-circle' /></span>
                        </div>)}
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._handleSubmit)}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {itemsLoaded && closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

function mapToProps(state, props) {
    const orders = state.application.get('orders').get('orders');
    const order = props.isNew ? undefined : orders.find(o => o.Id === props.initialValues.Id);
    order.Items.forEach(i => i.Service = i.FullName);
    if (order.TotalOrderPrice === undefined)
        order.TotalOrderPrice = 0;
    props.initialValues.Items = order.Items;

    const service = state.application.get('serviceCategory').get('service');
    const addresses = state.application.get('addresses');
    const delivery = state.application.get('settings')[settingTypes.delivery];
    const deliveryCancelFetching = state.application.get('delivery').cancelFetching;
    const deliveryCancelError = state.application.get('delivery').cancelError;
    const workTime = state.application.get('orders').get('workTime');
    const department = state.application.get('settings')[settingTypes.departments];
    const formValues = getFormValues(formName)(state);
    const isReceptionPoint = order.OrderType == RECEIVING_POINT_ORDER_TYPE;
    const updateResult = state.application.get('orders').get('updateResult');
    const updateError = state.application.get('orders').get('updateError');

    return {
        itemsFetching: order.itemsFetching,
        service: service.services,
        serviceFetching: service.fetching,
        fetchedAddresses: addresses,
        delivery,
        deliveryCancelFetching,
        deliveryCancelError,
        workTime,
        department,
        formValues,
        isReceptionPoint,
        updateResult,
        updateError
    }
}

Edit = reduxForm({
    form: formName,
    validate,
    onChange
})(Edit);

Edit = connect(mapToProps, {
    fetchOrderItemsAction,
    fetchServicesAction,
    fetchAddressesAction,
    getSettingsAction,
    deliveryCancelAction,
    getAvailableOffloadDate,
    getAvailablePickupDate,
    clearPickupAndOffloadDate,
    formValueChange, 
    manualCompletion,
    getFormValues
})(Edit);

export default Edit;


// WEBPACK FOOTER //
// ./src/components/orders/Edit.jsx